import * as types from '../../mutation-types'
// import dashboard from './dashboard'
import contacts from './contacts'
import documents from './documents'
import forms from './forms'
import soundfiles from './soundfiles'
import devices from './devices'
import speeddials from './speeddials'
import pagegroups from './pagegroups'
import ringgroups from './ringgroups'
import ivrmenus from './ivrmenus'
import schedulers from './schedulers'
import announcements from './announcements'
import conferences from './conferences'
import digitqueries from './digitqueries'
import voicemails from './voicemails'
import fonenumbers from './fonenumbers'
import locations from './locations'
import automation from './automation'
import calleridblacklist from './calleridblacklist'
// import integrations from './integrations'

const state = {
  items: [
    // dashboard,
    fonenumbers,
    devices,
    speeddials,
    announcements,
    conferences,
    digitqueries,
    ivrmenus,
    pagegroups,
    ringgroups,
    schedulers,
    voicemails,
    calleridblacklist,
    contacts,
    documents,
    forms,
    soundfiles,
    locations,
    automation
    // integrations
  ],
  features: [
    speeddials,
    announcements,
    conferences,
    digitqueries,
    ivrmenus,
    pagegroups,
    ringgroups,
    schedulers,
    calleridblacklist
  ],
  resources: [
    fonenumbers,
    devices,
    voicemails,
    contacts,
    documents,
    forms,
    locations,
    soundfiles,
    automation
  ]
}

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem
    let expand = payload.expand
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand
    }
  }
}

const actions = {
  toggleExpandMenuItem ({commit}, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js